import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';

let headers = {};

let BACKEND_URL = 'https://webapi.servicemav.com/api'
const domain = window.location.origin;


if (domain == "https://app.servicemav.com") {
    BACKEND_URL = 'https://webapi.servicemav.com/api';
}
else {
    BACKEND_URL = 'https://webapi.servicemav.com/api';
}

const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers
});

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = reactLocalStorage.get('token');
        if (token && !config['noAuth']) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    (response) =>
        new Promise((resolve, reject) => {
            resolve(response);
        }),
    (error) => {
        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        if (error.response.status === 403) {

        }
        else if (error.response.status === 401) {
            // A 401 means whatever token we're holding is dead — clear it
            // ALWAYS, including while on /login. Not clearing it here was the
            // login-lockout bug: after a password reset the app lands on /login
            // still holding a stale token, the request interceptor re-attaches
            // it to the login POST, and every retry re-sent the same dead token.
            // (The backend now ignores tokens on /login too, but clearing the
            // stale one is the right hygiene regardless.) A fresh tab only
            // escaped because it hit another page first and cleared it there.
            localStorage.removeItem('token');
            localStorage.removeItem('role')
            localStorage.removeItem('is_logged')
            localStorage.removeItem('userData')
            localStorage.removeItem('permissions')
            // Only redirect when we're NOT already on /login — redirecting to
            // the page you're on would reload-loop and swallow the error.
            if (window.location.pathname != '/login') {
                window.location = "/login";
            }
            else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        }
        else {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    },
);

export default axiosInstance;